import Heading from "../ui/Heading.jsx";

function Roadmap() {
    const roadmap = [
        {
            quarter: "Phase 1",
            title: "Laying the Foundations",
            status: "In progress",
            items: [
                "Weekly / regular events",
                "More events in more Australian cities",
                "More local businesses (bars, brands, collectives, stores)",
            ],
        },
        {
            quarter: "Phase 2",
            title: "Stay in the Loop",
            status: "Planned",
            items: [
                "Newsletters for your favourite parties (follow a party → get updates)",
                "APAC parties (when Aussies travel internationally)",
            ],
        },
        {
            quarter: "Phase 3",
            title: "Make It Yours",
            status: "Planned",
            items: [
                "Free user accounts to personalise your experience",
            ],
        },
    ];

    const statusClass = (status) => {
        switch (status) {
            case "In progress":
                return "bg-yellow-100 text-yellow-800 ring-1 ring-yellow-200";
            case "Planned":
            default:
                return "bg-pink-100 text-pink-800 ring-1 ring-pink-200";
        }
    };

    return (
        <div className="pt-10 mx-auto w-full max-w-2xl px-4 pb-10">
            <Heading className="text-center font-bold mb-4">
                2026 Roadmap
            </Heading>

            <p className="text-center text-gray-600">
                We’re building UnicornNation out in the open, powered by the herd, sprinkled with magic.
                Here’s what’s coming in 2026!
            </p>

            <div className="mt-8 space-y-4">
                {roadmap.map((q) => (
                    <div
                        key={q.quarter}
                        className="bg-white rounded-2xl shadow-lg border border-pink-100 overflow-hidden"
                    >
                        <div className="p-5">
                            <div className="flex items-start justify-between gap-3">
                                <div>
                                    <div className="flex items-center gap-2">
                                        <span className="text-sm font-semibold text-pink-600">
                                          {q.quarter}
                                        </span>
                                            <span
                                                className={`text-xs font-medium px-2 py-1 rounded-full ${statusClass(
                                                    q.status
                                                )}`}
                                                title={q.status}
                                            >
                                          {q.status}
                                        </span>
                                    </div>

                                    <h3 className="mt-1 text-lg font-semibold text-gray-900">
                                        {q.title}
                                    </h3>
                                </div>

                                <div className="w-8 h-8 select-none" aria-hidden="true">
                                    <img
                                        src="/Uni-symbol-2col.png"
                                        
                                        alt=""
                                        className="w-full h-full object-contain"
                                        draggable={false}
                                    />
                                </div>

                            </div>

                            <ul className="mt-4 space-y-2">
                                {q.items.map((item, idx) => (
                                    <li key={idx} className="flex gap-2 text-gray-700">
                                        <span className="mt-1.5 h-2 w-2 rounded-full bg-pink-400 flex-shrink-0" />
                                        <span className="text-sm leading-relaxed">{item}</span>
                                    </li>
                                ))}
                            </ul>
                        </div>
                    </div>
                ))}
            </div>

            <div className="mt-8 rounded-2xl border border-pink-100 bg-pink-50 p-5">
                <p className="text-center text-gray-700 font-medium">
                    Got ideas? We’re all ears (and horns).
                </p>
                <p className="text-center text-gray-600 mt-1">
                    Do you have suggestions about features we should add to the platform?
                </p>

                <p className="text-center text-gray-600 mt-3">
                    Email us directly at{" "}
                    <a
                        href="mailto:contact@unicornation.com.au?subject=UnicornNation%20Feedback"
                        className="font-medium text-pink-600 hover:text-pink-700 underline"
                    >
                        contact@unicornation.com.au
                    </a>
                </p>
            </div>
        </div>
    );
}

export default Roadmap;
